const Video = () => {

  const callsVideoModal = document.querySelectorAll('[data-videoid]')
  
  callsVideoModal.forEach(el => {
    el.addEventListener('click', function (event) {
      event.preventDefault()
      
      let elVideoModal = el.nextElementSibling
      let iframe = elVideoModal.querySelector('iframe')
      let close = elVideoModal.querySelector('.close-modal')
      
      if(iframe.src != window.location.href){
        iframe.src = ''
      }else{
        const videoid = this.dataset.videoid
        iframe.src = videoid

        close.addEventListener('click', function (event) {
          event.preventDefault()
          
          elVideoModal.classList.remove('show')
          iframe.src = ''
        })
      }

      elVideoModal.classList.add('show')
    })
  })


}

export default Video
